import React from 'react'
import { Link } from 'react-router-dom'
import TableShell from '../../../components/ui/TableShell'
import ActBadges from '../../../components/ui/ActBadges'

const money = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 })

export default function IncomeReportActs({ acts, periodLabel }) {
  return (
    <section className="report-acts-section" aria-labelledby="report-acts-title">
      <h2 id="report-acts-title" className="ds-section-heading">Акты за {periodLabel || 'период'}</h2>
      {acts == null ? (
        <p className="info-note">Список актов появится после обновления отчёта из актов.</p>
      ) : acts.length === 0 ? (
        <p className="info-note">Нет актов за этот период.</p>
      ) : (
        <TableShell className="report-acts-scroll">
          <table className="ds-data-table report-acts-table">
            <thead><tr><th>Акт</th><th>Объект / стадия</th><th>Дата выставления</th><th>Сумма</th><th>Тип оплаты / статус</th><th>Распределение</th></tr></thead>
            <tbody>{acts.map((act) => (
              <tr key={act.act_id}>
                <td><Link to={`/act/${encodeURIComponent(act.act_id)}`}>{act.act_number || act.act_id}</Link></td>
                <td>{act.object_name || '—'}<br /><span className="ds-detail-list__muted">{act.stage_id || '—'}</span></td>
                <td>{act.issue_date ? String(act.issue_date).slice(0, 10).split('-').reverse().join('.') : '—'}</td>
                <td className="amount-mono">{money.format(Number(act.amount) || 0)} ₽</td>
                <td><ActBadges act={act} /></td>
                <td>{act.distribution_exclusion_reason || 'Участвует в распределении'}</td>
              </tr>
            ))}</tbody>
          </table>
        </TableShell>
      )}
    </section>
  )
}
